import Vue from 'vue'
import axios from '../plugins/axios'

Vue.prototype.$http = axios

const global = {
    namespaced: true,
    state: {
        leftMenuClosed: null,
        maintenance: false
    },
    mutations: {
        setLeftMenuClosed(state, value) {
            state.leftMenuClosed = value
        },
        setMaintenance(state, value) {
            state.maintenance = value
        }
    },
    actions: {
        async checkMaintenance({ commit }) {
            Vue.prototype.$http.get('/maintenance-status').then((res) => {
                if (res.body.maintenance !== undefined) {
                    commit('setMaintenance', res.body.maintenance)
                } else {
                    // si même ce endpoint échoue, on considère qu'on est en maintenance
                    commit('setMaintenance', true)
                }
            })
        }
    }
}

export default global